var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h180v180H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.8 28.224 66.916 109.022A11 11 0 0 1 160.341 154H19.891c-6.076 0-11-4.925-11-11a11 11 0 0 1 1.682-5.847L79.01 28.105c4.11-6.549 12.75-8.526 19.3-4.416a14 14 0 0 1 4.49 4.535z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77 68)",
    fill: "#EBEBEB"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 47,
    width: 17,
    height: 17,
    rx: 4.664
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.196 0h15.608a4.664 4.664 0 0 1 4.636 5.166l-3.322 30.672A4.664 4.664 0 0 1 17.48 40H8.519a4.664 4.664 0 0 1-4.637-4.162L.56 5.166A4.664 4.664 0 0 1 5.196 0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageError);
export default __webpack_public_path__ + "static/media/image_error.c3b3f7720e35baa34244c1f97596942f.svg";
export { ForwardRef as ReactComponent };